import { replacePattern } from '/products/disneylorcana/common/components/js/env.js?20260925';

$(function () {
    const rulefaqQuestion = document.querySelectorAll('.p-rulefaq-faq__list-qa-item-question');
    const rulefaqAnswer = document.querySelectorAll('.p-rulefaq-faq__list-qa-item-answer-text');

    const replaceText = (items) => {
        items.forEach(item => {
            let textContent = item.innerHTML;

            replacePattern.forEach(([pattern, replacement]) => {
                textContent = textContent.replace(pattern, replacement);
            });

            item.innerHTML = textContent;
        });
    };

    replaceText(rulefaqQuestion);
    replaceText(rulefaqAnswer);
});